import { render } from "./SaveNationality.vue?vue&type=template&id=69df92cb"
import script from "./SaveNationality.vue?vue&type=script&lang=js"
export * from "./SaveNationality.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__